import { createRouter, createWebHistory } from "vue-router";
import NewPresupuestoPage from "@/pages/NewPresupuestoPage.vue";
import NewVentaPage from "@/pages/NewVentaPage.vue";
import NewGastoPage from "@/pages/NewGastoPage.vue";
import PresupuestosPage from "@/pages/PresupuestosPage.vue";
import ProductosPage from "@/pages/ProductosPage.vue";
import ClientesPage from "@/pages/ClientesPage.vue";

import LoginPage from "@/pages/LoginPage.vue";
import HomePage from "@/pages/HomePage.vue";
import AuthStateHelper from "@/helpers/authStateHelper"; // Importar el helper para manejar autenticación
import VentasPage from "./pages/VentasPage.vue";
import GastosPage from "./pages/GastosPage.vue";
import ReportesPage from "./pages/ReportesPage.vue";

import EscanerPage from "@/pages/EscanerPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta: { requiresAuth: true, },
    // Requiere autenticación
  },
  {
    path: "/reportes",
    name: "Reportes",
    component: ReportesPage,
    meta: { requiresAuth: true },
  },
  // Requiere autenticación
  {
    path: "/venta",
    name: "Nueva Venta",
    component: NewVentaPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/gasto",
    name: "Nuevo Gasto",
    component: NewGastoPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/gastos",
    name: "Gastos",
    component: GastosPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/ventas",
    name: "Ventas",
    component: VentasPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/presupuesto",
    name: "Presupuesto",
    component: NewPresupuestoPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/presupuestos",
    name: "Presupuestos",
    component: PresupuestosPage,
    meta: { requiresAuth: true }, // No requiere autenticación
  },
  {
    path: "/productos",
    name: "Productos",
    component: ProductosPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/clientes",
    name: "Clientes",
    component: ClientesPage,
    meta: { requiresAuth: true }, // Requiere autenticación
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { requiresAuth: false }, // No requiere autenticación
  },
  {
    path: "/escaner",
    name: "Escaner",
    component: EscanerPage,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(), // Utiliza el historial de navegador (modo moderno)
  routes,
});

// Guardia global para verificar autenticación
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!AuthStateHelper.getAuth();

  if (to.meta.requiresAuth && !isLoggedIn) {
    // Si la ruta requiere autenticación y el usuario no está autenticado, redirige al login
    next({ name: "Login" });
  } else {
    // Si está autenticado o la ruta no requiere autenticación, permite la navegación
    next();
  }
});

export default router;
